import { useContext, createContext } from "react";
import React from "react";

export interface LinkProps extends Omit<React.HTMLProps<HTMLAnchorElement>, "href"> {
  to: string;
}

interface ILinkContext {
  Component: React.FC<LinkProps>;
}

export const LinkContext = createContext<ILinkContext | null>(null);

/**
 * A link component that can be configured to work with different routers. Components in @travellocal/ui can
 * use this component and it'll be replaced with the required Link component.
 * 
 * See documentation in Storybook for more information.
 */
export const Link: React.FC<LinkProps> = ({ to, children, ...htmlProps }) => {
  const linkContext = useContext(LinkContext);
  if (!linkContext) {
    throw new Error("@travellocal/ui/Link must be used within a LinkContext.");
  }

  const { Component } = linkContext;

  return (
    <Component to={to} {...htmlProps}>
      {children}
    </Component>
  );
};

Link.displayName = "Link";
